"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcrossMerkleDistributor__factory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "caller",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "windowIndex",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "accountIndex",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "address",
                name: "rewardToken",
                type: "address",
            },
        ],
        name: "ClaimFor",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "caller",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "windowIndex",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "accountIndex",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "address",
                name: "rewardToken",
                type: "address",
            },
        ],
        name: "Claimed",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "windowIndex",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "rewardsDeposited",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "address",
                name: "rewardToken",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "owner",
                type: "address",
            },
        ],
        name: "CreatedWindow",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "windowIndex",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "owner",
                type: "address",
            },
        ],
        name: "DeleteWindow",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "claimer",
                type: "address",
            },
            {
                indexed: true,
                internalType: "bool",
                name: "whitelist",
                type: "bool",
            },
        ],
        name: "WhitelistedClaimer",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "address",
                name: "currency",
                type: "address",
            },
        ],
        name: "WithdrawRewards",
        type: "event",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "windowIndex",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "amount",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "accountIndex",
                        type: "uint256",
                    },
                    {
                        internalType: "address",
                        name: "account",
                        type: "address",
                    },
                    {
                        internalType: "bytes32[]",
                        name: "merkleProof",
                        type: "bytes32[]",
                    },
                ],
                internalType: "struct MerkleDistributorInterface.Claim",
                name: "_claim",
                type: "tuple",
            },
        ],
        name: "claim",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "windowIndex",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "amount",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "accountIndex",
                        type: "uint256",
                    },
                    {
                        internalType: "address",
                        name: "account",
                        type: "address",
                    },
                    {
                        internalType: "bytes32[]",
                        name: "merkleProof",
                        type: "bytes32[]",
                    },
                ],
                internalType: "struct MerkleDistributorInterface.Claim",
                name: "_claim",
                type: "tuple",
            },
        ],
        name: "claimFor",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "windowIndex",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "amount",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "accountIndex",
                        type: "uint256",
                    },
                    {
                        internalType: "address",
                        name: "account",
                        type: "address",
                    },
                    {
                        internalType: "bytes32[]",
                        name: "merkleProof",
                        type: "bytes32[]",
                    },
                ],
                internalType: "struct MerkleDistributorInterface.Claim[]",
                name: "claims",
                type: "tuple[]",
            },
        ],
        name: "claimMulti",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "windowIndex",
                type: "uint256",
            },
        ],
        name: "deleteWindow",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "windowIndex",
                type: "uint256",
            },
        ],
        name: "getRewardTokenForWindow",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "windowIndex",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "accountIndex",
                type: "uint256",
            },
        ],
        name: "isClaimed",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "merkleWindows",
        outputs: [
            {
                internalType: "bytes32",
                name: "merkleRoot",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "remainingAmount",
                type: "uint256",
            },
            {
                internalType: "contract IERC20",
                name: "rewardToken",
                type: "address",
            },
            {
                internalType: "string",
                name: "ipfsHash",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "nextCreatedIndex",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "rewardsToDeposit",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "rewardToken",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "merkleRoot",
                type: "bytes32",
            },
            {
                internalType: "string",
                name: "ipfsHash",
                type: "string",
            },
        ],
        name: "setWindow",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "windowIndex",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "amount",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "accountIndex",
                        type: "uint256",
                    },
                    {
                        internalType: "address",
                        name: "account",
                        type: "address",
                    },
                    {
                        internalType: "bytes32[]",
                        name: "merkleProof",
                        type: "bytes32[]",
                    },
                ],
                internalType: "struct MerkleDistributorInterface.Claim",
                name: "_claim",
                type: "tuple",
            },
        ],
        name: "verifyClaim",
        outputs: [
            {
                internalType: "bool",
                name: "valid",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newContract",
                type: "address",
            },
            {
                internalType: "bool",
                name: "whitelist",
                type: "bool",
            },
        ],
        name: "whitelistClaimer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "whitelistedClaimers",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IERC20",
                name: "rewardCurrency",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "withdrawRewards",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
class AcrossMerkleDistributor__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (args.length === 1) {
            super(_abi, _bytecode, args[0]);
        }
        else {
            super(...args);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.AcrossMerkleDistributor__factory = AcrossMerkleDistributor__factory;
AcrossMerkleDistributor__factory.bytecode = _bytecode;
AcrossMerkleDistributor__factory.abi = _abi;
